export default __webpack_public_path__ + "static/media/Arch_Amazon-Cloudwatch_2400.b92743ce.png";